import React, { useState, useEffect } from "react";
import { ReactComponent as ArrowDown } from "assets/svgs/accordion-arrow.svg";

const Accordion = ({ heading, className, arrowFill, children, dependencies, shouldClose }) => {
    const [opened, setOpened] = useState(false);

    useEffect(() => {
        if (shouldClose) setOpened(false);
    }, dependencies || []);

    return (
        <div className={`bg-inherit px-5 py-0.5 ${className || ""}`}>
            <div
                role="button"
                tabIndex={0}
                onClick={() => setOpened((prevState) => !prevState)}
                onKeyDown={(event) => event.key === "Enter" && setOpened((prevState) => !prevState)}
                className="flex hover:cursor-pointer items-center justify-between w-full"
                aria-label={heading}
            >
                <span className="link-heading text-inherit py-1.5">
                    {heading}
                </span>
                <div className={`w-3 h-3 flex transition-all duration-500 ${opened ? "rotate-180" : false}`}>
                    <ArrowDown fill={arrowFill ?? "#00344e"} />
                </div>
            </div>
            <div 
                aria-expanded={opened}
                aria-hidden={!opened}
                aria-label="Sublinks"
                className={`transition-all duration-500 overflow-hidden lg:max-h-full ${opened ? "max-h-[35rem] visible" : "max-h-[0rem] invisible"}`}
            >
                { children }
            </div>
        </div>
    );
};

export default Accordion;
